import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ErrorBoundary from "./components/ErrorBoundary";

import './assets/css/App.css';
import './assets/css/theme.css'
import 'react-toastify/dist/ReactToastify.css';
import Home from './pages/Home/Home';
import Checkout_post from './pages/Checkout_post/index';
import Login_Message from './pages/Login_Message/index';
///import Account from './pages/Account';
import  Panel from './pages/panel/Panel';
import Wallet from './pages/panel/Wallet';
import Change_password from "./pages/panel/Change_password";
import My_orders from "./pages/panel/My_orders";
import My_address from "./pages/panel/My_address";
import My_order_view from "./pages/panel/Order_view/My_order_view";
import Course_single_view from './pages/Course_single/Course_single_view';

import PanelCourse from './pages/panel/My_course/PanelCourse';
 import Metting_Panel from './pages/panel/My_course/Metting_page_view/Metting_Panel';
function App() {
  if (!localStorage.getItem('cart')) {
    localStorage.setItem('cart' , JSON.stringify([]))
    localStorage.setItem('price' , 0)
  }

  if (!localStorage.getItem('themes_status')) {
    localStorage.setItem("themes_status","white");
  }


  return (
      <div className="App">
        <ErrorBoundary>

          <Router>

            {/*<Router basename={"/namaava/"}>*/}



            <Routes>
              <Route path="/" element={<Home />}></Route>

              <Route path="/course-category/:id_cat_getuser" element={<Home />}></Route>


              <Route path="/panel/profile" element={<Panel />} />

              <Route path="/panel/wallet" element={<Wallet />} />
              <Route path="/panel/change-password" element={<Change_password />} />
              <Route path="/panel/my-orders" element={<My_orders />} />

              <Route path="/panel/my-address" element={<My_address />} />

              <Route path="/panel/my-orders/view/:id_post_getuser" element={<My_order_view />} />
              <Route path="/panel/my-courses" element={<PanelCourse />} />
              <Route path="/panel/my-course/:id_post_getuser/:lesson_id" element={<Metting_Panel />} />
              <Route path="/panel/my-course/:id_post_getuser/:lesson_id/:post_type" element={<Metting_Panel />} />


              <Route path="/course/:id_post_getuser" element={<Course_single_view />} />

              <Route path="/checkout/:id_post_getuser" element={<Checkout_post />} />
              <Route path="/login" element={<Login_Message />} />





            </Routes>
          </Router>

        </ErrorBoundary>

    </div>
  );
}

export default App;
